import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ExternalLink } from "@/components/UI/ExternalLink";
import { HeaderIcon } from "@/components/Layout/header/HeaderIcon";
import { HEADER_NAV_ITEMS, resolveHref } from "@/constants/navigation";
import type { HeaderNavItem } from "@/constants/navigation";
import { useLanguage } from "@/hooks/useLanguage";
import "./HeaderNavigation.css";

interface HeaderNavigationProps {
  variant: "desktop" | "mobile";
  onNavigate?: () => void;
}

export function HeaderNavigation({
  variant,
  onNavigate,
}: HeaderNavigationProps) {
  const listClassName = variant === "desktop"
    ? "site-header__nav-list"
    : "site-header__mobile-nav-list";

  return (
    <ul className={listClassName}>
      {HEADER_NAV_ITEMS.map((item) => (
        <HeaderNavigationItem
          key={item.id}
          item={item}
          variant={variant}
          onNavigate={onNavigate}
        />
      ))}
    </ul>
  );
}

function HeaderNavigationItem({
  item,
  variant,
  onNavigate,
}: {
  item: HeaderNavItem;
  variant: HeaderNavigationProps["variant"];
  onNavigate?: () => void;
}) {
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const itemClassName = variant === "desktop"
    ? "site-header__nav-item"
    : "site-header__mobile-nav-item";
  const className = variant === "desktop"
    ? `site-header__link site-header__link--${item.id}`
    : "site-header__mobile-link";

  if (item.type === "internal") {
    return (
      <li className={itemClassName}>
        <NavLink
          to={item.to}
          reloadDocument={item.to.includes("#")}
          end={item.end}
          className={className}
          onClick={onNavigate}
        >
          {t(item.labelKey)}
        </NavLink>
      </li>
    );
  }

  return (
    <li className={itemClassName}>
      <ExternalLink
        href={resolveHref(item.href, lang)}
        className={className}
        onClick={onNavigate}
      >
        {variant === "desktop" && item.withGithubIcon ? (
          <HeaderIcon name="github" />
        ) : null}
        {t(item.labelKey)}
      </ExternalLink>
    </li>
  );
}
